module.exports = __webpack_public_path__ + "img/evapharma.3dc30a56.jpg";